import React from 'react';
import { Card, Descriptions, Tag, Typography, Button, Space } from 'antd';
import { billing } from '../../mockData';
import './Subscription.css';

function Subscription() {
  const { Title } = Typography;

  const sub = billing.subscription;

  return (
    <div className="agency-billing-subscription">
      <Title level={3}>Agency Subscription</Title>
      <Card>
        <Descriptions title={`${sub.plan} Plan`} column={2} bordered size="small">
          <Descriptions.Item label="Status" span={1}>
            <Tag color={sub.status === 'active' ? 'green' : 'default'}>{sub.status.toUpperCase()}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Seats" span={1}>{sub.seats}</Descriptions.Item>
          <Descriptions.Item label="Price / Month" span={1}>${sub.pricePerMonth}</Descriptions.Item>
          <Descriptions.Item label="Renews On" span={1}>{sub.renewsOn}</Descriptions.Item>
        </Descriptions>
        <Space style={{ marginTop: 16 }}>
          <Button type="primary">Manage Plan</Button>
          <Button>Update Payment Method</Button>
        </Space>
      </Card>
    </div>
  );
}

export default Subscription;
